module.exports = __webpack_public_path__ + "fox.png";